import { useState } from 'react';

const useGalleryControls = () => {
  const [isGalleryVisible, setIsGalleryVisible] = useState(false);
  const [galleryImagePath, setGalleryImagePath] = useState('');

  const showGallery = (path) => {
    setIsGalleryVisible(true);
    setGalleryImagePath(path);
  };

  const closeGallery = () => {
    setIsGalleryVisible(false);
    setGalleryImagePath('');
  };

  return {
    isGalleryVisible,
    galleryImagePath,
    closeGallery,
    showGallery,
  };
};

export default useGalleryControls;
